import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"

import { Century } from "@/domains/centuries/model"

import { isUndefined } from "./refinements"

// -----------------------------------------------------------------------------
// Common internationalization messages
// -----------------------------------------------------------------------------

export const nth = (n: number) =>
  t({
    id: "nth",
    comment: "Ordinal number",
    message: `${n}.`,
  })

export const nthCentury = (century: Century) =>
  t({
    id: "nthCentury",
    comment: "Century ordinal (1st century, 2nd century, ...)",
    message: `${century}. století`,
  })

const formatOrdinalsList = (items: Array<string>): string => {
  if (isUndefined(Intl.ListFormat)) {
    return items.join(", ")
  }

  return new Intl.ListFormat(i18n.locale, {
    style: "long",
    type: "conjunction",
  }).format(items)
}

export const centuriesList = (centuries: Array<number>): string => {
  const centuryOrdinalsList = centuries.map(nth)
  const formattedCenturyOrdinalsList = formatOrdinalsList(centuryOrdinalsList)

  return t({
    id: "centuriesList",
    comment:
      "Example: '19th century', '19th and 20th century', '19th, 20th and 21st century', ...",
    message: `${formattedCenturyOrdinalsList} století`,
  })
}
